import { useEffect, useContext, useRef } from 'react';
import { CartContext } from '../../store/CartContext';
import { Modal } from 'bootstrap';
import useBrand from '../../hooks/useBrand';
import parse from 'html-react-parser';

import '../../scss/exit-modal.scss';

// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
VehicleMaintenanceModal.propTypes = {
  item: PropTypes.object.isRequired,
};

export default function VehicleMaintenanceModal({ item }) {
  const [cartState, cartDispatch] = useContext(CartContext);
  const { domain } = useBrand();

  const VITE_APP_MODE = import.meta.env.MODE;
  const NODE_ENV = process.env.NODE_ENV.toLowerCase();
  const isDevMode = import.meta.env.DEV;

  let shopUrl = `https://dlshop.${domain}`;

  // Check if the hostname contains a subdomain
  const isSubdomain = domain.split('.').length > 2;
  const separator = isSubdomain ? '-' : '.';

  if (VITE_APP_MODE === 'localDev' && isDevMode) {
    shopUrl = `https://shop${separator}${domain}`;
  }
  if (NODE_ENV === 'staging') {
    shopUrl = `https://mlshop${separator}${domain}`;
  }
  if (NODE_ENV === 'production') {
    shopUrl = `https://shop${separator}${domain}`;
  }

  const checkUrl = `${shopUrl}/checkout/?cartId=${cartState.cartId}`;
  const vehicleMaintenanceModalPID = '6264d1fd-7607-42f2-9667-3b4f24957e07';

  const upsellModalEl = useRef();
  const checkoutBtn = useRef(null);

  useEffect(() => {
    if (cartState.userExperience.showUpsellModal) {
      // hack to manually remove the existing modal backdrop during rerender
      document.querySelector('.modal-backdrop') && document.querySelector('.modal-backdrop').remove();
      document.querySelector('body').style.overflow = null;
      document.querySelector('body').style.paddingRight = null;

      const modal = new Modal(upsellModalEl.current, {
        backdrop: 'static',
        keyboard: false,
      });

      modal.show();

      checkoutBtn.current = document.querySelector('button.checkout-btn');
      upsellModalEl.current.addEventListener('hidden.bs.modal', () => {
        checkoutBtn.current.focus();
      });
    }
  }, [cartState.userExperience.showUpsellModal]);

  const handleModalCheckout = () => {
    cartDispatch({
      type: 'EXPERIENCE',
      payload: {
        showUpsellModal: false,
        hasSeenUpsellModal: true,
      },
    });
    window.location.href = `/cart/?productId=${vehicleMaintenanceModalPID}&coupon=LIMITEDDEAL`;
  };

  // const handleModalClose = () => {
  //   cartDispatch({
  //     type: 'EXPERIENCE',
  //     payload: {
  //       viewedUpsells: true,
  //       showUpsellModal: false,
  //     },
  //   });
  // };

  const handleDeclineOffer = () => {
    sessionStorage.setItem('viewCheckout', true);
    cartDispatch({
      type: 'EXPERIENCE',
      payload: {
        viewedUpsells: true,
        showUpsellModal: false,
        hasSeenUpsellModal: true,
      },
    });
    window.location.href = checkUrl;
  };

  // find the vehicle maintenance upsell in the item.upSellProducts
  const vehicleMaintenanceUpsell = item.upSellProducts.find((upsell) => upsell.productId === vehicleMaintenanceModalPID);

  // if the vehicle maintenance upsell doesn't exist, return null
  if (!vehicleMaintenanceUpsell) {
    return null;
  }

  // get the name and description of the vehicle maintenance upsell
  const { name } = vehicleMaintenanceUpsell;

  return (
    <>
      <div
        className="modal fade text-center"
        ref={upsellModalEl}
        id="vehicle-maintenance-modal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="vehicle-maintenance-modal modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-body p-3 pt-3 px-3 pb-2 p-4 pt-4 pb-3" tabIndex="-1">
              <div className="row g-0">
                <div className="col-lg-5 d-none d-lg-flex">
                  <img
                    className="coupon-img"
                    src="data:image/svg+xml;base64,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"
                  />
                </div>

                <div className="col-12 col-lg-7 d-flex flex-column justify-content-center py-3">
                  <h3 className="discount-headline fw-700 h5 mt-0 mb-1">Limited Time Deal!</h3>
                  <p className="discount-amount fw-700 lh-12 mb-4">Only $2.99</p>
                  <h3 className="discount-headline fw-700 h5 mt-0 mb-1">{name}</h3>
                  <div className="discount-subcopy fw-500 mb-0">
                    Learn everything drivers need to know about basic car maintenance, from checking fluids to changing a
                    tire.
                  </div>
                  <button className="exit-btn" onClick={handleModalCheckout}>
                    Add to Cart
                  </button>
                  <div>
                    <button className="btn btn-link p-0 text-decoration-none" onClick={handleDeclineOffer}>
                      Continue Without Offer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
